import React from 'react';
import classNames from 'classnames';

import styles from './blocTeam.module.scss';

interface IBlocTeam {
    children: React.ReactNode;
    className?: string;
    title: string;
    isDark?: boolean;
    isFullSize?: boolean;
}

const BlocTeam = ({
    children, className = "", title, isDark, isFullSize,
}: IBlocTeam) => {
    return (
        <section
            data-component="BlocTeam"
            className={classNames(styles.me, {
                [className]: className,
                [styles.dark]: isDark,
                [styles.fullSize]: isFullSize,
            })}
        >
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.container}>
                {children}
            </div>
        </section>
    );
};

export default BlocTeam;
